import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
//import {Panel} from 'primereact/panel';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';

//import {InputSwitch} from 'primereact/inputswitch';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';    
import moment from 'moment';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
//import { ToggleButton } from 'primereact/togglebutton';
import { HASACCESS, TIME_DURATION, REDIRECT_TO_URL } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG, PUNCH_EDITING_SUBMENU_ID } from '../../../shared/Config';

class Punch extends Component {
    state = {
        display : true,
        type : 'add',
        punchtypes: [
            {label : 'IN', value: 'IN'},
            {label : 'OUT', value: 'OU'}], 
            trxType :'',
            trxDateTime :'',
            trxDate: '',
            trxTime: '',
            empBookingId :'',
            employeeId :'',
            employeeidu: '',
            userDefined1:'',
            userDefined2:'',
            userDefined3:'',
            userDefined4:'',
            userDefined5:'',
            userDefined6:'',
            attnDate:'',

            }


    componentDidMount(){       
        
        // this.props.getMasterTableList('Employee/GetProjectList');   
        this.props.getMasterKeywordList('Employee');
        
        this.getAccess = HASACCESS(PUNCH_EDITING_SUBMENU_ID);

        let type = this.props.match.params.type;
        if(type !== 'add'){
            setTimeout(() => {
                this.fetchSingleProcess();
            },1000)
        } else {
            // Get the logged-in user ID from Redux state or any other appropriate source
            this.setState({ userDefined2: this.props.loggedUserDetail.userID }); // Assuming 'id' is the property for user ID
          }

         

          this.fetchUserIP();
        }


    fetchSingleProcess = () =>{
   
        let id = this.props.match.params.id; 
        this.props.getMasterTableList(`GetTimeBookingSingle?Id=${id}`);  
        let type = this.props.match.params.type;
        let storageItems = [];

        if(this.props.tableLists && this.props.tableLists.length > 0) {
            storageItems = this.props.tableLists;
        }
        if(storageItems){
            let filterData = storageItems.filter(list => {
                return list.empBookingId ===id;
            }).reduce((arr,el) => {
                return el;
            },{});
        
       
          
            
            if(filterData){
                var data = {
                    type:type,
                    trxType :filterData.trxType,
                    trxDate : moment(this.state.trxDate).format('yyyy-mm-dd'),
                    trxTime : moment(this.state.trxTime).format('HH:mm:ss'),
                    empBookingId :filterData.empBookingId,
                    employeeId :filterData.employeeId,
                    employeeidu : filterData.employeeIdu,
                    userDefined1 : filterData.userDefined1,
                    userDefined2 : filterData.userDefined2,
                    userDefined3 : filterData.userDefined3,
                    userDefined4 : filterData.userDefined4,
                    userDefined5 : filterData.userDefined5,
                    userDefined6 : filterData.userDefined6,
                    attnDate     : filterData.attnDate,
                    
                }
                this.setState(data);
                
            }
        }

    }

        // Function to fetch the user's IP address
        fetchUserIP = async () => {
            try {
              const response = await fetch('https://api.ipify.org?format=json'); 
              const data = await response.json();
              this.setState({ userDefined6: data.ip });
            } catch (error) {
              console.error('Error fetching user IP:', error);
              
              this.setState({ userDefined6: 'Unable to fetch IP' });
            }
           
              
          }

    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeField(rowIndex)} ></Button>
        </div>;
    }

  
    add = () => {
        
        
        var dummy = this.state.employeeId

        function extractAllIds(data) {
            
            var empid = '';
            for (const index in data) {
                if (data.hasOwnProperty(index)) {
                    if (data[index].value === dummy){
                        empid = data[index].id;    
                    }
                }
            }
            return empid
            }

        var id = extractAllIds(this.props.Employee); // Assuming this.props.Employee is an object
        this.setState({employeeId: id});
        let data = {
            trxType :this.state.trxType,
            trxDateTime : moment(this.state.trxDate).format("YYYY-MM-DD")+' '+moment(this.state.trxTime).format("HH:mm:ss"),
            date: moment(this.state.trxDate).format("YYYY-MM-DD"),
            time: moment(this.state.trxTime).format("HH:mm:ss"),
            // empBookingId :this.state.empBookingId,
            employeeId :this.state.employeeId,
            employeeIdu : this.state.employeeidu,
            userDefined1 : this.state.userDefined1,
            userDefined2 : this.state.type === 'add'? this.props.loggedUserDetail.userID : this.state.userDefined2, //*"?"(check condition to add data), ":"(use for alternative data to insert)
            userDefined3 : this.state.type === 'add'? moment().format('YYYY-MM-DD HH:mm:ss') :this.state.userDefined3,
            userDefined4 : this.state.type === 'edit'? this.props.loggedUserDetail.userID:'' ,
            userDefined5 :  this.state.type === 'edit'? moment().format('YYYY-MM-DD HH:mm:ss') :'',
            userDefined6 :  String(this.state.userDefined6),
            attnDate     : moment(this.state.trxDate).format("YYYY-MM-DD")+' '+moment(this.state.trxTime).format("HH:mm:ss"),

        }
        

        if(this.state.type === 'edit'){
            data.empBookingId = this.state.empBookingId;
            data.empBookingId = this.props.match.params.id;
        }

        this.props.processDynamicData('Punch',this.state.type,data,`GetTimeBooking?Id=${this.state.employeeidu}&From_Date=${this.state.fromDate}&To_Date=${this.state.toDate}`);
        

    }

    resetData = () => {
        // Reset the state to its initial values
        this.setState({
            display : true,
            type : 'add',
            punchtypes: [
                {label : 'IN', value: 'IN'},
                {label : 'OUT', value: 'OU'}], 
                trxType :'',
                trxDateTime :'',
                trxDate: '',
                trxTime: '',
                // employeeId :'',
                employeeidu: '',
                userDefined1:'',
                // userDefined6:'',
                // attnDate:'',
        });
    }
    
    
    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }

    onTimeChange = (e) => {
        // Update the state with the new time selected by the user
        this.setState({
            trxTime: e.target.value
        });
    }
    
    removeField  = (removeIndex) => {

        const updatedDeptValue = this.state.rows.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({rows:updatedDeptValue})

    }

    Change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
      
        
      };

      
    render() {   

        

        if(this.props.success){
            REDIRECT_TO_URL('/punch-editing/',this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess};
        
        let showReasonField = this.state.type === 'add'; // Simplified condition

        
        return (

            <div className="p-grid ">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Attendance</h1>
           
                        <div className="p-grid mt2">

                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Employee <span className="requiredColor">*</span></label>
                                <div className="mt1"></div>
                                <Dropdown className="p-col-12" placeholder="Select Employee" options={this.props.Employee} value={this.state.employeeidu} 
                            onChange={e => this.Change(e)}  name="employeeidu" {...DROPDOWN_CONFIG} />
                            </div>

                           <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Punch Type <span className="requiredColor">*</span></label>
                                <div className="mt1"></div>
                                <Dropdown className="p-col-12" placeholder="Select Punch Type" options={this.state.punchtypes} value={this.state.trxType} 
                            onChange={e => this.Change(e)}  name="trxType" {...DROPDOWN_CONFIG} />
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Attendance Date <span className="requiredColor">*</span></label>
                                <div className="mt1"><Calendar className="p-col-12" name="trxDate" placeholder="Attendance Date " value={this.state.trxDate}  onChange={e => this.Change(e)}/></div>                              
                            </div>

                            
                            <div className="p-col-12 p-md-6 p-lg-2">
                                <label className="label">Attendance Time <span className="requiredColor">*</span></label>
                                <div className="mt1"><Calendar className="p-col-12" timeOnly={true} showTime={true} name="trxTime" placeholder="Attendance Time " value={this.state.trxTime}  onChange={e => this.Change(e)}/></div>                              
                            </div> 
                            

                             { showReasonField && ( // Conditionally render reason field
                                <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Reason <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="userDefined1" placeholder="Reason" value={this.state.userDefined1} onChange={e => this.Change(e)} />
                                </div>
                                </div>

                               )} 
                            

                            <div className="p-col-12 p-md-6 p-lg-6">
                            <label className="label">IP</label>
                            <div className="mt1">
                             <InputText className="p-col-12" name="userDefined6" placeholder="User Defined 6"   value={this.state.userDefined6 || ''} readOnly={true} /> 
                                 {/* Set to read-only to prevent manual edits */}
                            </div>
                            </div>

                            <div className="p-col-12 p-lg-12">
                            <FooterButton access={accessButton}  type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/punch-editing"} />
                            </div>
                            
                           
                        </div> 
                           
           
                       
                    </div>
                         
                </div>
                
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists,
       
       
        Employee: (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        
    }
}

const mapDispatchToProps = dispatch => {
    return {
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value))
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(Punch);